<mat-icon class="app-icon" [color]="color" [inline]="inline">{{ icon }}</mat-icon>
